import './HowItWorks.scss';

export const HowItWorks = () => (
  <section className='how-it-works'>
    <div className='container'>
      <div className='row'>
        <div className='col-12'>
          <h2>How It Works</h2>

          <div className='how-it-works-image-wrapper'>
            <img
              src='/img/partner-launch/how-it-works-timeline.png'
              alt='MyOme How It Works diagram'
              className='how-it-works-image'
            />
          </div>

          <ol className='steps-list'>
            <li className='step-item'>
              <h3 className='step-title'>Order Test</h3>
              <p className='step-description'>Request your test through the link.</p>
            </li>

            <li className='step-item'>
              <h3 className='step-title'>Collect Your Sample</h3>
              <p className='step-description'>
                Use a simple cheek swab collection kit (buccal kit) shipped directly to your home, and send it back
                using the pre-paid envelope.
              </p>
            </li>

            <li className='step-item'>
              <h3 className='step-title'>Receive Your Results</h3>
              <p className='step-description'>Get a detailed report with clear, actionable insights.</p>
            </li>

            <li className='step-item'>
              <h3 className='step-title'>Speak with a Genetic Counselor</h3>
              <p className='step-description'>Have questions? Our experts are here to guide you.</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
);
